import config from "config";

/**
 * Rewrite legacy public S3 object URLs to the configured CloudFront CDN.
 * Uses a single subsenterprise CDN for both console parent domains.
 */
export function toCdnUrl(url?: string | null): string {
  if (!url) return url as string;
  const cdnBase = (config.cdn?.uri || "").replace(/\/$/, "");
  if (!cdnBase) return url;

  try {
    const parsed = new URL(url);
    const host = parsed.hostname.toLowerCase();
    const cdnHost = new URL(cdnBase).hostname.toLowerCase();

    const isS3Host =
      host.includes(".s3.") ||
      host.endsWith(".amazonaws.com") ||
      host.startsWith("s3.");

    // Already on the active CDN host
    if (host === cdnHost) return url;

    if (isS3Host) {
      return `${cdnBase}${parsed.pathname}${parsed.search}`;
    }

    return url;
  } catch {
    return url;
  }
}
